import { useStore } from 'vuex'
export default function authVerify(to, from, next) {
    const store = useStore()
    store.dispatch("readToken")
    if (!store.state.auth){
        next('login')
    } else {
        next()
    }
  }